import { TableCellPropertiesElementBaseDestination } from './table-cell-properties-element-base-destination';
export class TableCellPropertiesLeafElementDestination extends TableCellPropertiesElementBaseDestination {
    get elementHandlerTable() {
        return {};
    }
}
